.content {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.counter {
  font-size: var(--font-size-sm, 14px);
  color: var(--color-neutral-500, #666);
  padding: 0.5rem 0;
  margin-bottom: 0.5rem;
  border-bottom: 1px solid var(--color-neutral-200, #E1E1E1);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2FnZW50L193b3JrLzE0L3Mvc2VudGluZWwtZnJvbnQvc3JjL3BhZ2VzL0Rhc2hib2FyZC9mcmFnbWVudHMvRmlsdGVyc0RyYXdlciIsInNvdXJjZXMiOlsiRmlsdGVyc0RyYXdlci5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBIiwic291cmNlc0NvbnRlbnQiOlsiLmNvbnRlbnQge1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBnYXA6IDAuMjVyZW07XG59XG5cbi5jb3VudGVyIHtcbiAgZm9udC1zaXplOiB2YXIoLS1mb250LXNpemUtc20sIDE0cHgpO1xuICBjb2xvcjogdmFyKC0tY29sb3ItbmV1dHJhbC01MDAsICM2NjYpO1xuICBwYWRkaW5nOiAwLjVyZW0gMDtcbiAgbWFyZ2luLWJvdHRvbTogMC41cmVtO1xuICBib3JkZXItYm90dG9tOiAxcHggc29saWQgdmFyKC0tY29sb3ItbmV1dHJhbC0yMDAsICNFMUUxRTEpO1xufVxuIl19 */